import React from 'react'
import './WineMerchantRedirect.scss' 
import { useDispatch, useSelector  } from 'react-redux';
import { updateCurrentView, showFawPage, resetSelection } from '../../actions/index';
import { DialogflowQueryType } from '../../widget/models/enum';
import { dialogflowEvent } from '../../config/config';
import { postMessageToClient } from '../../widget/chatservice/communicationService';


type WineMerchantRedirectPros = {
    updateWineExpert: (wineExpert: string) => void;
    selectWineExpert : string,
    quickReplyHandler: any
}

 const WineMerchantRedirect = ({updateWineExpert,selectWineExpert,quickReplyHandler}: WineMerchantRedirectPros ) => {
  const dispatch = useDispatch();
  const openTab= (e: any)=>{
    sendAnalyticsTag('web:chatbot:find a wine:find product expert:yes');
    handleDone(e);

    const objCall = {
    data : {},
      methodHandler : "callSalesFloorWidget",
      contextName : "landingPage"
    };

    postMessageToClient(objCall);
  }
  
  const cancelTab = (e: any)=>{
    sendAnalyticsTag('web:chatbot:find a wine:find product expert:no');
    dispatch(updateCurrentView('results'));
  }

  const sendAnalyticsTag = (linkName: string) => {
    const objCall = {
        data : {
            linkName : linkName.toLowerCase(),
            linkType: 'chatbot find a wine',
        },
        methodHandler : "chatbotTriggerAdobeAnalytics"
    }; 
    console.log(linkName);
    postMessageToClient(objCall);
}

  const handleDone = (e: any) => {
    dispatch(showFawPage(false));
    dispatch(resetSelection());
    quickReplyHandler(e, DialogflowQueryType.Event, dialogflowEvent.Chatbot_FAW_Followup_Questions, false);
}

  return (
    <div className="mainDiv">
        <div className="expert-wine">
            <img src="./images/benmoroney-expert.png" id="imgBen"  alt=""  />
            <img src="./images/malisacaroselli-expert.png" id="imgMalisa" alt=""/>
            <img src="./images/brucegordon-expert.png" id="imgBruc" alt="" />
        </div>
        <div className="heading">
            <h2>Want expert advice?</h2>
            <p>Connect with our Wine Merchants for personalised recommendations through live chat* or a 1-to-1 appointment.</p>
        </div>
        <div className="heading">
            <small>*Wine Merchants may be offline during busy periods in-store.<br/>
            <strong>Live chat hours:</strong> 10:00am to 4:00pm, Tues to Sat</small>
        </div>
        <div className="divButton">
      <button  className='button-primary' value="Yes, connect with a product expert" onClick={(event) => openTab(event)} >
      Yes, connect with a product expert
      <img src="./images/wine-merchant-btn.png"/>
      </button>
      <input type='button' className='button-secondary' value="No, get wine recommendation" onClick={(event) => cancelTab(event)} />

      </div>
    </div>
  )
}


export default WineMerchantRedirect
